import { Card, Row } from "react-bootstrap";

import "./downloaderCardStyles.css";

const DownloaderCard = ({ logo, label, icon, onClick }) => {
  return (
    <Card className="downloader-card">
      <Card.Body className="downloader-card-body">
        <Row className="d-flex align-items-center text-center mx-auto">
          <img className="img-fluid" src={logo} alt="logo" />
        </Row>
      </Card.Body>
      <Card.Footer className="downloader-card-footer">
        <button
          className="downloader-card-button d-flex align-items-center justify-content-center w-100"
          onClick={onClick}
        >
          {icon}
          <span className="ml-1">{label}</span>
        </button>
      </Card.Footer>
    </Card>
  );
};

export default DownloaderCard;
